import { render, staticRenderFns } from "./ExternalPensionDashboardItem.vue?vue&type=template&id=32e6fcb0&scoped=true"
import script from "./ExternalPensionDashboardItem.vue?vue&type=script&lang=js"
export * from "./ExternalPensionDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./ExternalPensionDashboardItem.vue?vue&type=style&index=0&id=32e6fcb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e6fcb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VProgressCircular,VRow})
